import React from "react";
import { Field } from "redux-form";

import { ASSET_TYPES } from "utils/constants";
import { formatBytes } from "utils/common";

import DynamicAssetSelect from "social/DynamicAssetSelect";
import DynamicInput from "social/DynamicInput";
import { useSocialFields } from "social/formats/utils";

import {
	MAX_VIDEO_BYTES,
	MAX_THUMBNAIL_BYTES,
	MIN_VIDEO_SEC,
	MAX_VIDEO_MIN
} from "./consts";
import { isRequiredAssetField } from "social/utils";
import { imposiumComposition } from "social/ImposiumCompSelector";
import { afterEffectsComposition } from "social/AfterEffectsCompSelector";

const VIDEO_ACCEPT = ".mp4, .mov";
const THUMBNAIL_ACCEPT = ".jpg, .jpeg, .png, .gif";

const FILE_SIZE_REQUIREMENT = { name: "File Size:", description: `${formatBytes(MAX_VIDEO_BYTES)} Maximum` };
const FILE_TYPE_REQUIREMENT = { name: "File Types:", description: VIDEO_ACCEPT };
const FILE_DURATION_REQUIREMENT = { name: "Duration:", description: `Between ${MIN_VIDEO_SEC} sec and ${MAX_VIDEO_MIN} min` };

const THUMBNAIL_REQUIREMENTS = [
	{
		name: "File Size:",
		description: `<= ${formatBytes(MAX_THUMBNAIL_BYTES)}`,
	},
	{
		name: "File Types:",
		description: THUMBNAIL_ACCEPT,
	},
];

const varNamePrefix = "ig_reels_";

export default function InstagramReels(props){
	const {
		libraryId,
		navigationActions,
		creativeAssetType,
	} = props;

	const baseFields = {
		imposiumComposition,
		afterEffectsComposition,
		video: {
			name: "video",
			label: "Video",
			className: "full-width",
			assetType: ASSET_TYPES.VIDEO,
			component: DynamicAssetSelect,
			defaultDynVarName: `${varNamePrefix}video`,
			dynamicToggleDisabled: true, // Only the default placement is allowed to toggle dynamic status on asset fields.
			requirements: [
				FILE_SIZE_REQUIREMENT,
				FILE_TYPE_REQUIREMENT,
				FILE_DURATION_REQUIREMENT,
				{ name: "Dimensions:", description: "250 pixels width or larger required, between 9:16 and 1.91:1 aspect ratio" }
			],
			creativeAssetType,
			required: isRequiredAssetField(creativeAssetType),
			accept: VIDEO_ACCEPT,
			tip: {
				direction: "top",
				description: "At least 1440x2560 for better placement compatibility",
			},
			libraryId,
			navigationActions,
		},
		thumbnail: {
			name: "thumbnail",
			label: "Thumbnail",
			className: "full-width",
			assetType: ASSET_TYPES.IMAGE,
			component: DynamicAssetSelect,
			defaultDynVarName: `${varNamePrefix}video_thumbnail`,
			dynamicToggleDisabled: true, // Only the default placement is allowed to toggle dynamic status on asset fields.
			requirements: THUMBNAIL_REQUIREMENTS,
			creativeAssetType,
			accept: THUMBNAIL_ACCEPT,
			libraryId,
			navigationActions,
		},
		primaryText: {
			name: "primaryText",
			label: "Primary Text",
			className: "full-width",
			placeholder: "Tell people what your creative is about",
			tip: {
				description: "May get truncated after 72 characters",
				direction: "right",
			},
			component: DynamicInput,
			type: "textarea",
			defaultDynVarName: `${varNamePrefix}copy`,
		},
		landingPage: {
			name: "landingPage",
			label: "Landing Page",
			className: "full-width",
			placeholder: "https://www.example.com",
			component: DynamicInput,
			defaultDynVarName: `${varNamePrefix}clickTag1`,
			required: true,
		},
	};

	const fieldProps = useSocialFields(baseFields, props);

	return (
		<div className="fields">
			{fieldProps.map((properties) => {
				return <Field key={properties.name} {...properties} />;
			})}
		</div>
	);
}

InstagramReels.displayName = "FacebookVideoMOIGReelsPlacement";
